import { Component, OnInit, Output, EventEmitter, TemplateRef } from '@angular/core';
import { EventService } from '../../core/services/event.service';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { PreferenceService, PreferenceType } from 'src/app/core/services/preference.service';
import { ThemeModel } from 'src/app/core/models/preference/theme-model';
import { PreferenceModel } from 'src/app/core/models/preference/preference-model';
import { AIChatModalService } from 'src/app/core/services/modal-services/ai-chat-modal.service';
import { AuthMyfileService } from 'src/app/core/services/auth.myfile.service';
import { Roles } from 'src/app/core/security/roles';

@Component({
  selector: 'app-rightsidebar',
  templateUrl: './rightsidebar.component.html',
  styleUrls: ['./rightsidebar.component.scss']
})

/**
 * Right Sidebar component
 */
export class RightsidebarComponent implements OnInit {

  layout: string | undefined;
  mode: string | undefined;
  width: string | undefined;
  position: string | undefined;
  topbar: string | undefined;
  size: string | undefined;
  sidebarView: string | undefined;
  sidebar: string | undefined;
  attribute: any;
  sidebarImage: any;
  preLoader: any;
  grd: any;

  pref?: PreferenceModel;

  isAIChatVisible: boolean = false;

  @Output() settingsButtonClicked = new EventEmitter();

  constructor(
    private eventService: EventService,
    private offcanvasService: NgbOffcanvas,
    private authMyfileService: AuthMyfileService,
    protected aiChatModalService: AIChatModalService,
    private userPreferenceService: PreferenceService) { }

  ngOnInit(): void {

    this.userPreferenceService.currentPreference
      .subscribe((data: PreferenceType) => {
        if (data) {
          this.layout = data.theme.layout;
          this.mode = data.theme.mode;
          this.width = data.theme.width;
          this.position = data.theme.position;
          this.topbar = data.theme.topbar;
          this.size = data.theme.size;
          this.sidebarView = data.theme.sidebarView;
          this.sidebar = data.theme.sidebar;
          this.sidebarImage = data.theme.sidebarImage;
          this.preLoader = data.theme.preLoader;
          this.attribute = '';
          this.pref = data;
        }
      });
    this.isAIChatVisible = this.authMyfileService.loginTypeIsUser() && !this.authMyfileService.isInRole(Roles.guest);
  }

  ngAfterViewInit() { }

  /**
   * Change the layout onclick
   * @param layout Change the layout
   */
  changeLayout(layout: string) {
    this.attribute = layout;
    document.body.setAttribute('layout', layout)
    if (layout == 'vertical')
      document.body.classList.remove('menu');
    this.eventService.broadcast('changeLayout', layout);
  }

  // Add Active Class
  addActive(grdSidebar: any) {
    this.grd = grdSidebar;
    document.documentElement.setAttribute('data-sidebar', grdSidebar)
    document.getElementById('collapseBgGradient')?.classList.toggle('show');
    document.getElementById('collapseBgGradient1')?.classList.add('active');
  }

  // Remove Active Class
  removeActive() {
    this.grd = '';
    document.getElementById('collapseBgGradient1')?.classList.remove('active');
    document.getElementById('collapseBgGradient')?.classList.remove('show');
  }

  // When the user clicks on the button, scroll to the top of the document
  topFunction() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }

  //  Filter Offcanvas Set
  openEnd(content: TemplateRef<any>) {
    this.offcanvasService.open(content, { position: 'end' });

    setTimeout(() => {
      this.attribute = document.documentElement.getAttribute('data-layout')
      if (this.attribute == 'vertical') {
        var vertical = document.getElementById('customizer-layout01') as HTMLInputElement;
        if (vertical != null) {
          vertical.setAttribute('checked', 'true');
        }
      }
      if (this.attribute == 'horizontal') {
        const horizontal = document.getElementById('customizer-layout02');
        if (horizontal != null) {
          horizontal.setAttribute('checked', 'true');
        }
      }
      if (this.attribute == 'twocolumn') {
        const Twocolumn = document.getElementById('customizer-layout03');
        if (Twocolumn != null) {
          Twocolumn.setAttribute('checked', 'true');
        }
      }
    }, 100);
  }

  openAIChat() {
    if(this.aiChatModalService.hasBeenLoaded()){
      this.aiChatModalService.openModal(false);
    }else{
      this.aiChatModalService.preload = true;
      this.aiChatModalService.openModal(true);
    }
  
  }

  // Mode Change
  changeMode(mode: string) {
    this.mode = mode;

    document.documentElement.setAttribute('data-layout-mode', mode);

    if (this.pref) {
      this.pref.theme.mode = mode;
      this.userPreferenceService.updateThemePreference(this.pref).subscribe();
    }
  }

  // Width Change
  changeWidth(width: string, size: string) {
    this.width = width;
    document.documentElement.setAttribute('data-layout-width', width);
    document.documentElement.setAttribute('data-sidebar-size', size)

    if (this.pref) {
      this.pref.theme.width = width;
      this.pref.theme.size = size;
      this.userPreferenceService.updateThemePreference(this.pref).subscribe();
    }
  }

  // Position Change
  changePosition(position: string) {
    this.position = position;
    document.documentElement.setAttribute('data-layout-position', position);

    if (this.pref) {
      this.pref.theme.position = position;
      this.userPreferenceService.updateThemePreference(this.pref).subscribe();
    }
  }

  // Topbar Change
  changeTopColor(color: string) {
    this.topbar = color;
    document.documentElement.setAttribute('data-topbar', color);

    if (this.pref) {
      this.pref.theme.topbar = color;
      this.userPreferenceService.updateThemePreference(this.pref).subscribe();
    }
  }

  // Sidebar Size Change
  changeSidebarSize(size: string) {
    this.size = size;
    document.documentElement.setAttribute('data-sidebar-size', size)

    if (this.pref) {
      this.pref.theme.size = size;
      this.userPreferenceService.updateThemePreference(this.pref).subscribe();
    }
  }

  // Sidebar Size Change
  changeSidebar(sidebar: string) {
    this.sidebarView = sidebar;
    document.documentElement.setAttribute('data-layout-style', sidebar);

    if (this.pref) {
      this.pref.theme.sidebarView = sidebar;
      this.userPreferenceService.updateThemePreference(this.pref).subscribe();
    }
  }

  // Sidebar Color Change
  changeSidebarColor(color: string) {
    this.sidebar = color;
    document.documentElement.setAttribute('data-sidebar', color)

    if (this.pref) {
      this.pref.theme.sidebar = color;
      this.userPreferenceService.updateThemePreference(this.pref).subscribe();
    }
  }

  // Sidebar Image Change
  changeSidebarImage(img: string) {
    this.sidebarImage = img;
    document.documentElement.setAttribute('data-sidebar-image', img);
    if (this.pref) {
      this.pref.theme.sidebarImage = img;
      this.userPreferenceService.updateThemePreference(this.pref).subscribe();
    }
  }

  // PreLoader Image Change
  changeLoader(loader: string) {
    this.preLoader = loader;
    document.documentElement.setAttribute('data-preloader', loader);
    var preloader = document.getElementById("preloader");
    if (preloader) {
      setTimeout(function () {
        (document.getElementById("preloader") as HTMLElement).style.opacity = "0";
        (document.getElementById("preloader") as HTMLElement).style.visibility = "hidden";
      }, 1000);
    }

    if (this.pref) {
      this.pref.theme.preLoader = loader;
      this.userPreferenceService.updateThemePreference(this.pref).subscribe();
    }
  }

}
